import React, { useRef, useEffect } from 'react';
import { InputCode } from './styles';

const AutoResizingInputCode = ({ value = '', onChange, device, ...props }) => {
  const inputRef = useRef(null);
  const isMobile = device === 'mobile';
  const adjustSize = () => {
    const input = inputRef.current;
    if (!input) return;

    if (isMobile) {
      input.style.width = '100%';
      input.style.height = '48px'; // reset
      input.style.height = `${input.scrollHeight}px`; // crecimiento vertical solo en mobile
    } else {
      input.style.height = '48px'; // altura fija
      input.style.width = 'fit-content'; // reset
      const contentWidth = input.scrollWidth;
      input.style.width = `${Math.max(contentWidth, 274)}px`; // crecimiento horizontal
    }
  };

  useEffect(() => {
    adjustSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, device]);

  const handleInput = e => {
    adjustSize();
    onChange(e);
  };

  return (
    <InputCode
      ref={inputRef}
      value={value}
      onInput={handleInput}
      onChange={onChange}
      isMobile={isMobile}
      data-publi='step-description-internalCode-textArea'
      {...props}
    />
  );
};

export default AutoResizingInputCode;
